(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-home"] && !Shopify.designMode) return;
  try {
    
  // hero-home.liquid — featured-song player + scroll-aware sticky CTA.
  // Player: real <audio> play/pause/seek/restart/repeat; progress painted by
  // setting --p on the scrub track (its gradient does the rest). The "browse"
  // (next-icon) control is a plain link to the library.
  (function () {
    function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var m = Math.floor(s / 60), x = s % 60; return m + ':' + (x < 10 ? '0' : '') + x; }
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

    document.querySelectorAll('[data-hh-player]').forEach(function (root) {
      var audio = root.querySelector('[data-hh-audio]');
      var scrub = root.querySelector('[data-hh-scrub]');
      var cur = root.querySelector('[data-hh-cur]');
      var dur = root.querySelector('[data-hh-dur]');
      if (!audio) return;

      function paint(p) {
        p = clamp(p, 0, 1);
        if (scrub) { scrub.style.setProperty('--p', (p * 100).toFixed(2) + '%'); scrub.setAttribute('aria-valuenow', String(Math.round(p * 100))); }
      }
      function toggle() {
        if (audio.paused) {
          document.querySelectorAll('audio').forEach(function (o) { if (o !== audio) o.pause(); });
          audio.play().catch(function () {});
        } else {
          audio.pause();
        }
      }
      root.querySelectorAll('[data-hh-play]').forEach(function (b) { b.addEventListener('click', toggle); });
      var restart = root.querySelector('[data-hh-restart]');
      if (restart) restart.addEventListener('click', function () { audio.currentTime = 0; audio.play().catch(function () {}); });
      var repeat = root.querySelector('[data-hh-repeat]');
      if (repeat) repeat.addEventListener('click', function () { audio.loop = !audio.loop; repeat.setAttribute('aria-pressed', audio.loop ? 'true' : 'false'); });

      audio.addEventListener('play', function () { root.setAttribute('data-playing', ''); });
      audio.addEventListener('pause', function () { root.removeAttribute('data-playing'); });
      audio.addEventListener('ended', function () { paint(0); if (cur) cur.textContent = '0:00'; });
      audio.addEventListener('loadedmetadata', function () { if (dur && isFinite(audio.duration)) dur.textContent = fmt(audio.duration); });
      audio.addEventListener('timeupdate', function () { var d = audio.duration || 0; paint(d ? audio.currentTime / d : 0); if (cur) cur.textContent = fmt(audio.currentTime); });

      if (scrub) {
        var seek = function (x) {
          var r = scrub.getBoundingClientRect();
          var f = clamp((x - r.left) / r.width, 0, 1);
          if (isFinite(audio.duration) && audio.duration) { audio.currentTime = f * audio.duration; paint(f); if (cur) cur.textContent = fmt(audio.currentTime); }
        };
        var drag = false;
        scrub.addEventListener('pointerdown', function (e) { drag = true; try { scrub.setPointerCapture(e.pointerId); } catch (err) {} seek(e.clientX); });
        scrub.addEventListener('pointermove', function (e) { if (drag) seek(e.clientX); });
        scrub.addEventListener('pointerup', function () { drag = false; });
        scrub.addEventListener('pointercancel', function () { drag = false; });
        scrub.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration); }
          else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
        });
      }
      paint(0);
    });

    // Sticky CTA scroll-aware visibility
    var sticky = document.querySelector('.hero-home__sticky-cta');
    var heroCta = document.querySelector('.hero-home__ctas .sb-btn');
    if (sticky && heroCta && 'IntersectionObserver' in window) {
      sticky.inert = true;
      var io = new IntersectionObserver(function (entries) {
        var hidden = entries[0].isIntersecting;
        sticky.setAttribute('data-visible', hidden ? 'false' : 'true');
        sticky.inert = hidden;
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(heroCta);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  function slugify(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function toRoman(n) {
    var map = [[10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']], out = '';
    for (var i = 0; i < map.length; i++) {
      while (n >= map[i][0]) { out += map[i][1]; n -= map[i][0]; }
    }
    return out;
  }

  function init() {
    var content = document.querySelector('.art-content');
    if (!content) return;
    var headings = content.querySelectorAll('h2');

    // Relocate the inline CTA to just before the Nth H2 (progressive enhancement).
    var cta = document.getElementById('art-inline-cta');
    if (cta && headings.length) {
      var after = parseInt(cta.getAttribute('data-after'), 10);
      if (!after || after < 1) after = 2;
      if (headings.length >= after) {
        headings[after - 1].insertAdjacentElement('beforebegin', cta);
      }
    }

    // Build the Contents from the H2s — roman numeral + period, title, dot leader.
    var aside = document.getElementById('art-toc');
    var list = document.getElementById('art-toc-list');
    var layout = document.getElementById('art-layout');
    if (!aside || !list || headings.length < 2) {
      if (aside) aside.parentNode.removeChild(aside);
    } else {
      var anchors = [];
      var seen = {};
      Array.prototype.forEach.call(headings, function (h, i) {
        var id = h.id;
        if (!id) {
          id = slugify(h.textContent) || 'section-' + (i + 1);
          if (seen[id]) id = id + '-' + (i + 1);
          h.id = id;
        }
        seen[id] = true;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        var num = document.createElement('span');
        num.className = 'art-toc-n';
        num.textContent = toRoman(i + 1) + '.';
        var txt = document.createElement('span');
        txt.className = 'art-toc-t';
        txt.textContent = h.textContent;
        var ldr = document.createElement('span');
        ldr.className = 'art-toc-ldr';
        a.appendChild(num);
        a.appendChild(txt);
        a.appendChild(ldr);
        li.appendChild(a);
        list.appendChild(li);
        anchors.push(a);
      });

      aside.hidden = false;
      if (layout) layout.classList.add('art-layout--toc');

      // Scroll-spy: highlight the section currently in view.
      if ('IntersectionObserver' in window) {
        var byId = {};
        anchors.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              anchors.forEach(function (a) { a.classList.remove('is-active'); });
              var match = byId[e.target.id];
              if (match) match.classList.add('is-active');
            }
          });
        }, { rootMargin: '-12% 0px -70% 0px' });
        Array.prototype.forEach.call(headings, function (h) { obs.observe(h); });
      }
    }

    // Reading-progress bar (the sticky TOC needs no JS to show/hide).
    var bar = document.querySelector('.art-progress');
    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, doc.scrollTop / max)) : 0;
      if (bar) bar.style.width = (p * 100) + '%';
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    // Exit-intent offer: desktop pointers only, armed after 6s, once per visitor.
    // Never fires on load — mouseout at the viewport top is the only trigger.
    var exit = document.querySelector('[data-exit]');
    if (exit && window.matchMedia('(min-width: 1000px) and (pointer: fine)').matches) {
      var KEY = 'sb_exit_seen';
      var armed = false;
      var seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
      setTimeout(function () { armed = true; }, 6000);
      function showExit() {
        if (seen || !armed) return;
        seen = true;
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        exit.hidden = false;
      }
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) showExit();
      });
      exit.addEventListener('click', function (e) { if (e.target === exit) exit.hidden = true; });
      Array.prototype.forEach.call(exit.querySelectorAll('[data-exit-close]'), function (b) {
        b.addEventListener('click', function () { exit.hidden = true; });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') exit.hidden = true; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collab"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.clb').forEach(function (root) {
      if (root.__clbWired) return;
      root.__clbWired = true;

      [].slice.call(root.querySelectorAll('.clb-card')).forEach(function (card) {
        var a = card.querySelector('[data-clb-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-clb-play]');
        var prog = card.querySelector('.clb-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });

      var sticky = root.querySelector('[data-clb-sticky]');
      var heroCtas = root.querySelector('[data-clb-heroctas]');
      if (sticky && heroCtas && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var below = entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', !entry.isIntersecting && below);
          });
        }, { threshold: 0 }).observe(heroCtas);
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-song"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);
      recalc();

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEls=cs.querySelectorAll('[data-error]');
      var errEl=errEls[0]||null; // kept for the re-enable path below
      function showErr(m){
        var scrolled=false;
        errEls.forEach(function(el){
          el.textContent=m; el.hidden=false;
          // scroll to the first VISIBLE error (the quiz card's, when the rail is hidden)
          if(!scrolled && el.offsetParent!==null){ scrolled=true; try{ el.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} }
        });
      }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(function(){
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(items.length){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}); }
        }).then(function(){ window.location.href='/checkout'; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-editorial"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function money(c){ return "$" + (c/100).toFixed(2); }

    document.querySelectorAll('.cs').forEach(function(cs){
      var d=cs.dataset;
      var baseId=d.baseId, baseCents=parseInt(d.baseCents,10)||0;
      var exId=d.exId, exCents=parseInt(d.exCents,10)||0;
      var inId=d.inId, inCents=parseInt(d.inCents,10)||0;
      var plId=d.plId, plCents=parseInt(d.plCents,10)||0;

      // The brief (recipient/occasion/story/voice + adaptive prompts + context pre-fill)
      // is the shared snippets/song-brief.liquid; it self-wires and exposes .sbBrief.
      var brief=cs.querySelector('[data-song-brief]');

      // totals
      var exCb=cs.querySelector('[data-add="ex"]'), inCb=cs.querySelector('[data-add="in"]'), plCb=cs.querySelector('[data-add="pl"]');
      var exRow=cs.querySelector('[data-exrow]'), inRow=cs.querySelector('[data-inrow]'), plRow=cs.querySelector('[data-plrow]');
      var baseNameEl=cs.querySelector('[data-base-name]'), basePriceEl=cs.querySelector('[data-base-price]');
      function recalc(){
        var t=baseCents;
        if(exCb&&exCb.checked){ t+=exCents; if(exRow) exRow.hidden=false; } else if(exRow){ exRow.hidden=true; }
        if(inCb&&inCb.checked){ t+=inCents; if(inRow) inRow.hidden=false; } else if(inRow){ inRow.hidden=true; }
        if(plCb&&plCb.checked){ t+=plCents; if(plRow) plRow.hidden=false; } else if(plRow){ plRow.hidden=true; }
        cs.querySelectorAll('[data-total],[data-cta-total],[data-total-sticky]').forEach(function(e){ e.textContent=money(t); });
      }
      if(exCb) exCb.addEventListener('change',recalc);
      if(inCb) inCb.addEventListener('change',recalc);
      if(plCb) plCb.addEventListener('change',recalc);

      // Keepsake single-select (the .cs-hold band). Each card is a full-price
      // variant ("song in [form]"), so choosing one SETS the base cart line —
      // it is not an add-on. The buy-box base row + total follow the choice.
      var kkCards=cs.querySelectorAll('[data-kv]'), selName='';
      function selectKeepsake(card){
        if(!card) return;
        baseId=card.getAttribute('data-vid');
        baseCents=parseInt(card.getAttribute('data-vcents'),10)||baseCents;
        selName=card.getAttribute('data-vname')||'';
        kkCards.forEach(function(c){ var on=(c===card); c.classList.toggle('on',on); c.setAttribute('aria-checked',on?'true':'false'); });
        if(baseNameEl) baseNameEl.textContent=selName;
        if(basePriceEl) basePriceEl.textContent=money(baseCents);
        recalc();
      }
      kkCards.forEach(function(card){ card.addEventListener('click',function(){ selectKeepsake(card); }); });
      // Sync the buy box to the pre-selected card (the product's default variant).
      var onCard=cs.querySelector('[data-kv].on')||kkCards[0];
      if(onCard){ selectKeepsake(onCard); } else { recalc(); }

      // Sample players (now in the .cs-samples grid below) self-wire via
      // snippets/song-player.liquid (play/pause/seek/progress; pause others on play).

      // submit -> cart (rail CTA + mobile sticky CTA share one handler)
      var btn=cs.querySelector('[data-submit]'), sbtn=cs.querySelector('[data-submit-sticky]'), errEl=cs.querySelector('[data-error]');
      function showErr(m){ if(errEl){ errEl.textContent=m; errEl.hidden=false; try{ errEl.scrollIntoView({block:'center',behavior:'smooth'}); }catch(e){} } }

      // Plaque upsell modal (Pride): on first CTA click, offer the plaque before checkout.
      var pModal=cs.querySelector('[data-plaque-modal]'), wantPlaque=false, plaqueDecided=false;
      function closeModal(){ if(pModal) pModal.hidden=true; }
      if(pModal){
        var pYes=pModal.querySelector('[data-plaque-yes]'), pNo=pModal.querySelector('[data-plaque-no]'), pX=pModal.querySelector('[data-plaque-close]');
        if(pYes) pYes.addEventListener('click',function(){ wantPlaque=true; plaqueDecided=true; closeModal(); proceed(); });
        if(pNo) pNo.addEventListener('click',function(){ wantPlaque=false; plaqueDecided=true; closeModal(); proceed(); });
        if(pX) pX.addEventListener('click',closeModal);
        pModal.addEventListener('click',function(e){ if(e.target===pModal) closeModal(); });
      }

      function doSubmit(){
        if(errEl) errEl.hidden=true;
        if(!brief||!brief.sbBrief){ showErr('Something went wrong. Please refresh and try again.'); return; }
        var msg=brief.sbBrief.validate();
        if(msg){ showErr(msg); return; }
        if(pModal && !plaqueDecided){ pModal.hidden=false; return; }
        proceed();
      }
      function proceed(){
        var props=brief.sbBrief.collect(), voice=brief.sbBrief.getVoice();
        var fd=new FormData();
        fd.append('id', baseId); fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
        if(voice) fd.append('properties[Voice note]', voice.blob, voice.name);
        var orig=btn?btn.innerHTML:'';
        if(btn){ btn.disabled=true; btn.textContent='Adding…'; } if(sbtn){ sbtn.disabled=true; }
        fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); }).then(function(){
          var items=[];
          if(exCb&&exCb.checked&&exId) items.push({id:exId,quantity:1});
          if(inCb&&inCb.checked&&inId) items.push({id:inId,quantity:1});
          if(wantPlaque&&plId) items.push({id:plId,quantity:1});
          if(items.length){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})}); }
        }).then(function(){ window.location.href='/checkout'; }).catch(function(){ if(btn){ btn.disabled=false; btn.innerHTML=orig; } if(sbtn){ sbtn.disabled=false; } showErr('Something went wrong adding to cart. Please try again.'); });
      }
      if(btn) btn.addEventListener('click',doSubmit);
      if(sbtn) sbtn.addEventListener('click',doSubmit);
      var sticky=cs.querySelector('[data-sticky]');
      if(sticky && btn && 'IntersectionObserver' in window){
        sticky.inert = true; // off-screen until the primary CTA scrolls away
        var io=new IntersectionObserver(function(e){ var hidden=e[0].isIntersecting; sticky.setAttribute('data-visible', hidden ? 'false' : 'true'); sticky.inert = hidden; }, { threshold: 0 });
        io.observe(btn);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-keepsake-plaque"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.kp').forEach(function(kp){
      var mainImg = kp.querySelector('.kp-main-img');
      var thumbs = kp.querySelectorAll('.kp-thumb');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var full = t.getAttribute('data-full');
          if (mainImg && full) { mainImg.src = full; }
          thumbs.forEach(function(x){ x.classList.remove('on'); });
          t.classList.add('on');
        });
      });

      var plaqueVid = kp.getAttribute('data-variant-id');
      var songVid = kp.getAttribute('data-song-vid');
      var soloVid = kp.getAttribute('data-songonly-vid');
      var cta = kp.querySelector('[data-cta]');
      var mode = 'song';
      var ctaLabel = { song: 'Create your song + plaque →', plaque: 'Personalize your plaque →', solo: 'Create your song →' };
      var promiseEl = kp.querySelector('[data-promise]');
      var shipPromise = promiseEl ? promiseEl.innerHTML : '';
      var promiseHTML = {
        song: shipPromise,
        plaque: shipPromise,
        solo: '<b>Unlimited revisions</b> — we refine the song until you love it. Nothing ships; it’s digital.'
      };

      kp.querySelectorAll('.kp-opt').forEach(function(opt){
        opt.addEventListener('click', function(){
          mode = opt.getAttribute('data-opt');
          kp.querySelectorAll('.kp-opt').forEach(function(o){
            var on = o === opt;
            o.classList.toggle('on', on);
            o.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          kp.querySelectorAll('[data-whats]').forEach(function(w){ w.hidden = (w.getAttribute('data-whats') !== mode); });
          if (cta) { cta.textContent = ctaLabel[mode]; }
          if (promiseEl && promiseHTML[mode]) { promiseEl.innerHTML = promiseHTML[mode]; }
        });
      });

      var lastFocus = null;
      function openModal(m){
        if (!m) { return; }
        lastFocus = document.activeElement;
        m.hidden = false;
        document.body.style.overflow = 'hidden';
        var f = m.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(m){
        if (!m) { return; }
        m.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
      }
      kp.querySelectorAll('.kp-modal').forEach(function(m){
        m.querySelectorAll('[data-modal-close]').forEach(function(c){ c.addEventListener('click', function(){ closeModal(m); }); });
      });
      document.addEventListener('keydown', function(e){
        if (e.key !== 'Escape') { return; }
        kp.querySelectorAll('.kp-modal').forEach(function(m){ if (!m.hidden) { closeModal(m); } });
      });
      if (cta) {
        cta.addEventListener('click', function(){ openModal(kp.querySelector('[data-modal="' + mode + '"]')); });
      }

      function wireFile(input, wrapSel, labelSel){
        if (!input) { return function(){ return null; }; }
        var wrap = input.closest(wrapSel);
        var label = wrap ? wrap.querySelector(labelSel) : null;
        input.addEventListener('change', function(){
          if (input.files && input.files[0]) {
            if (label) { label.textContent = '✓ ' + input.files[0].name; }
            if (wrap) { wrap.classList.add('is-on'); }
          }
        });
        return function(){ return (input.files && input.files[0]) ? input.files[0] : null; };
      }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }
      function val(el){ return el ? (el.value || '').trim() : ''; }
      function collectProps(scope, attr){
        var out = {};
        scope.querySelectorAll('[' + attr + ']').forEach(function(el){ var v = val(el); if (v) { out[el.getAttribute(attr)] = v; } });
        return out;
      }

      var songModal = kp.querySelector('[data-modal="song"]');
      if (songModal) {
        var step1 = songModal.querySelector('[data-step="1"]');
        var step2 = songModal.querySelector('[data-step="2"]');
        var nextBtn = songModal.querySelector('[data-step-next]');
        var backBtn = songModal.querySelector('[data-step-back]');
        var err1 = songModal.querySelector('[data-error]');
        var err2 = songModal.querySelector('[data-error2]');
        var submitS = songModal.querySelector('[data-submit="song"]');
        var brief = songModal.querySelector('[data-song-brief]');
        var getPhotoS = wireFile(songModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');

        if (nextBtn) {
          nextBtn.addEventListener('click', function(){
            if (err1) { err1.hidden = true; }
            var msg = (brief && brief.sbBrief) ? brief.sbBrief.validate() : '';
            if (msg) { err1.textContent = msg; err1.hidden = false; return; }
            step1.hidden = true; step2.hidden = false;
          });
        }
        if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

        if (submitS) {
          submitS.addEventListener('click', function(){
            if (err2) { err2.hidden = true; }
            if (!brief || !brief.sbBrief) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; return; }
            var msg = brief.sbBrief.validate();
            if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
            var props = brief.sbBrief.collect();
            var p2 = collectProps(step2, 'data-pk');
            Object.keys(p2).forEach(function(k){ props[k] = p2[k]; });
            var voice = brief.sbBrief.getVoice();
            var orig = submitS.textContent;
            submitS.disabled = true; submitS.textContent = 'Adding…';
            addItem(songVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }, { key: 'Photo', file: getPhotoS() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitS.disabled = false; submitS.textContent = orig; err2.textContent = 'Something went wrong adding to cart. Please try again.'; err2.hidden = false; });
          });
        }
      }

      var plaqueModal = kp.querySelector('[data-modal="plaque"]');
      if (plaqueModal) {
        var errP = plaqueModal.querySelector('[data-error]');
        var submitP = plaqueModal.querySelector('[data-submit="plaque"]');
        var getPhotoP = wireFile(plaqueModal.querySelector('[data-photo]'), '.kp-pfile', '[data-plabel]');
        if (submitP) {
          submitP.addEventListener('click', function(){
            if (errP) { errP.hidden = true; }
            var props = collectProps(plaqueModal, 'data-pk');
            var orig = submitP.textContent;
            submitP.disabled = true; submitP.textContent = 'Adding…';
            addItem(plaqueVid, props, [{ key: 'Photo', file: getPhotoP() }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitP.disabled = false; submitP.textContent = orig; errP.textContent = 'Something went wrong adding to cart. Please try again.'; errP.hidden = false; });
          });
        }
      }

      var soloModal = kp.querySelector('[data-modal="solo"]');
      if (soloModal) {
        var errSolo = soloModal.querySelector('[data-error]');
        var submitSolo = soloModal.querySelector('[data-submit="solo"]');
        var briefSolo = soloModal.querySelector('[data-song-brief]');
        if (submitSolo) {
          submitSolo.addEventListener('click', function(){
            if (errSolo) { errSolo.hidden = true; }
            if (!briefSolo || !briefSolo.sbBrief) { errSolo.textContent = 'Something went wrong. Please refresh and try again.'; errSolo.hidden = false; return; }
            var msg = briefSolo.sbBrief.validate();
            if (msg) { errSolo.textContent = msg; errSolo.hidden = false; return; }
            var props = briefSolo.sbBrief.collect();
            var voice = briefSolo.sbBrief.getVoice();
            var orig = submitSolo.textContent;
            submitSolo.disabled = true; submitSolo.textContent = 'Adding…';
            addItem(soloVid, props, [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }])
              .then(function(){ window.location.href = '/checkout'; })
              .catch(function(){ submitSolo.disabled = false; submitSolo.textContent = orig; errSolo.textContent = 'Something went wrong adding to cart. Please try again.'; errSolo.hidden = false; });
          });
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-occasion-keepsake"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.ok').forEach(function(ok){
      var mainImg = ok.querySelector('.ok-main-img');
      var stickyPrice = ok.querySelector('[data-sticky-price]');
      var ctaPrice = ok.querySelector('[data-cta-price]');
      var ptitle = ok.getAttribute('data-ptitle') || '';
      var origTitle = document.title;
      var titleTail = (ptitle && origTitle.indexOf(ptitle) === 0) ? origTitle.slice(ptitle.length) : '';
      var sel = { vid: null, name: '', price: '', personalize: false, photo: false };
      var cardList = Array.prototype.slice.call(ok.querySelectorAll('.ok-cc'));
      var slider = ok.querySelector('[data-slider]');
      var dotsWrap = ok.querySelector('[data-sldots]');
      var thumbs = Array.prototype.slice.call(ok.querySelectorAll('.ok-thumb'));
      var curIndex = 0, scrollLock = false, dots = [];

      function selectCard(card, fromUser){
        curIndex = cardList.indexOf(card);
        ok.querySelectorAll('.ok-cc').forEach(function(c){ c.classList.remove('on'); c.setAttribute('aria-selected','false'); });
        card.classList.add('on'); card.setAttribute('aria-selected','true');
        sel.vid = card.getAttribute('data-vid');
        if (thumbs.length) { thumbs.forEach(function(t){ t.classList.toggle('on', t.getAttribute('data-thumb-vid') === sel.vid); }); }
        sel.name = card.getAttribute('data-name');
        sel.price = card.getAttribute('data-price');
        if (stickyPrice) { stickyPrice.textContent = sel.price; }
        if (ctaPrice && sel.price) { ctaPrice.textContent = sel.price; }
        sel.personalize = card.getAttribute('data-personalize') === '1';
        sel.photo = card.getAttribute('data-photo') === '1';
        var img = card.getAttribute('data-img');
        if (mainImg && img) { mainImg.src = img; }
        if (fromUser) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', sel.vid); history.replaceState({}, '', u.toString()); } catch (e) {}
          if (ptitle && sel.name) { document.title = ptitle + ' — ' + sel.name + titleTail; }
        }
      }
      function paintDots(i){ dots.forEach(function(d, j){ d.classList.toggle('on', j === i); }); }
      function goToIndex(i, scroll){
        if (i < 0 || i >= cardList.length) { return; }
        if (scroll && slider) {
          scrollLock = true;
          slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
          setTimeout(function(){ scrollLock = false; }, 400);
        }
        paintDots(i);
        selectCard(cardList[i], true);
      }
      // dots — one per keepsake (supplementary control; the card grid is the accessible one)
      if (dotsWrap && cardList.length > 1) {
        cardList.forEach(function(_, i){
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'ok-sldot' + (i === 0 ? ' on' : '');
          d.setAttribute('tabindex', '-1'); d.setAttribute('aria-hidden', 'true');
          d.addEventListener('click', function(){ goToIndex(i, true); });
          dotsWrap.appendChild(d); dots.push(d);
        });
      }
      // tap a card → scroll the slider to it (and select)
      cardList.forEach(function(card, i){
        card.addEventListener('click', function(){ goToIndex(i, true); });
      });
      // click a desktop thumbnail → select the matching keepsake (swaps hero + grid + price + URL)
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var card = ok.querySelector('.ok-cc[data-vid="' + t.getAttribute('data-thumb-vid') + '"]');
          if (card) { goToIndex(cardList.indexOf(card), true); }
        });
      });
      // swipe the slider → select the matching card (guard against the programmatic scroll)
      if (slider) {
        var raf;
        slider.addEventListener('scroll', function(){
          if (scrollLock) { return; }
          if (raf) { cancelAnimationFrame(raf); }
          raf = requestAnimationFrame(function(){
            var i = Math.round(slider.scrollLeft / slider.clientWidth);
            if (i !== curIndex && cardList[i]) { paintDots(i); selectCard(cardList[i], true); }
          });
        });
      }
      var urlVar = null;
      try { urlVar = new URLSearchParams(window.location.search).get('variant'); } catch (e) {}
      var startCard = (urlVar && ok.querySelector('.ok-cc[data-vid="' + urlVar + '"]')) || ok.querySelector('.ok-cc.on') || ok.querySelector('.ok-cc');
      if (startCard) {
        selectCard(startCard, !!urlVar);
        var si = cardList.indexOf(startCard); if (si < 0) { si = 0; }
        if (slider) { slider.scrollLeft = si * slider.clientWidth; }
        paintDots(si);
      }

      // modal
      var modal = ok.querySelector('[data-modal]');
      var step1 = modal.querySelector('[data-step="1"]');
      var step2 = modal.querySelector('[data-step="2"]');
      var brief = modal.querySelector('[data-song-brief]');
      var pwrap = modal.querySelector('[data-pwrap]');
      var photoInput = modal.querySelector('[data-photo]');
      var plabel = modal.querySelector('[data-plabel]');
      var err1 = modal.querySelector('[data-err1]');
      var err2 = modal.querySelector('[data-err2]');
      var submitBtn = modal.querySelector('[data-submit]');
      var nextBtn = modal.querySelector('[data-next]');
      var lastFocus = null;

      function openModal(){
        lastFocus = document.activeElement;
        modal.hidden = false; document.body.style.overflow = 'hidden';
        step2.hidden = true; step1.hidden = false;
        if (nextBtn) { nextBtn.textContent = sel.personalize ? 'Next: make it yours →' : 'Continue to checkout →'; }
        var f = step1.querySelector('input, select, textarea, button');
        if (f) { f.focus(); }
      }
      function closeModal(){ modal.hidden = true; document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) { lastFocus.focus(); } }
      ok.querySelectorAll('[data-open]').forEach(function(b){ b.addEventListener('click', openModal); });

      // sticky mobile CTA — reveal once the main button scrolls out of view
      var sticky = ok.querySelector('[data-sticky]');
      var primaryCta = ok.querySelector('.ok-buy > .ok-cta');
      if (sticky && primaryCta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){ sticky.classList.toggle('on', !e.isIntersecting); });
        }, { rootMargin: '0px 0px -45% 0px' }).observe(primaryCta);
      } else if (sticky) {
        sticky.classList.add('on');
      }
      modal.querySelectorAll('[data-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) { closeModal(); } });

      if (photoInput) {
        photoInput.addEventListener('change', function(){
          if (photoInput.files && photoInput.files[0]) {
            if (plabel) { plabel.textContent = '✓ ' + photoInput.files[0].name; }
            if (pwrap) { pwrap.classList.add('is-on'); }
          }
        });
      }

      function val(el){ return el ? (el.value || '').trim() : ''; }
      function briefOk(){ return brief && brief.sbBrief; }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(){
          if (err1) { err1.hidden = true; }
          var msg = briefOk() ? brief.sbBrief.validate() : '';
          if (msg) { if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          if (sel.personalize) {
            if (pwrap) { pwrap.hidden = !sel.photo; }
            step1.hidden = true; step2.hidden = false;
            var f2 = step2.querySelector('input, button'); if (f2) { f2.focus(); }
          } else {
            doAdd();
          }
        });
      }
      var backBtn = modal.querySelector('[data-back]');
      if (backBtn) { backBtn.addEventListener('click', function(){ step2.hidden = true; step1.hidden = false; }); }

      function addItem(variantId, props, files){
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        Object.keys(props).forEach(function(k){ if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
        (files || []).forEach(function(f){ if (f && f.file) { fd.append('properties[' + f.key + ']', f.file, f.name || f.file.name || 'file'); } });
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function(r){ if (!r.ok) { throw new Error('add'); } return r.json(); });
      }

      function doAdd(){
        if (!briefOk()) { return; }
        var props = brief.sbBrief.collect();
        props['Keepsake'] = sel.name;
        if (sel.personalize) {
          step2.querySelectorAll('[data-pk]').forEach(function(el){ var v = val(el); if (v) { props[el.getAttribute('data-pk')] = v; } });
        }
        var voice = brief.sbBrief.getVoice();
        var files = [{ key: 'Voice note', file: voice ? voice.blob : null, name: voice ? voice.name : null }];
        if (sel.photo && photoInput) { files.push({ key: 'Photo', file: (photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null }); }
        var btn = sel.personalize ? submitBtn : nextBtn;
        var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        var errBox = sel.personalize ? err2 : err1;
        addItem(sel.vid, props, files)
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ btn.disabled = false; btn.textContent = orig; if (errBox) { errBox.textContent = 'Something went wrong adding to cart. Please try again.'; errBox.hidden = false; } });
      }
      if (submitBtn) {
        submitBtn.addEventListener('click', function(){
          if (err2) { err2.hidden = true; }
          if (!briefOk()) { if (err2) { err2.textContent = 'Something went wrong. Please refresh and try again.'; err2.hidden = false; } return; }
          var msg = brief.sbBrief.validate();
          if (msg) { step2.hidden = true; step1.hidden = false; if (err1) { err1.textContent = msg; err1.hidden = false; } return; }
          doAdd();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-plaque-personalize"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.pp').forEach(function (pp) {
      if (pp.__ppWired) { return; }
      pp.__ppWired = true;

      /* gallery */
      var mainImg = pp.querySelector('.pp-main-img');
      var thumbs = pp.querySelectorAll('.pp-thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (mainImg && full) { mainImg.src = full; }
          thumbs.forEach(function (x) { x.classList.remove('on'); });
          t.classList.add('on');
        });
      });

      /* selected variant — SKU-agnostic, driven purely by product.variants.
         Prices are pre-formatted by Liquid (money filter) and carried on the
         option cards, so the JS never formats currency itself. */
      var vid = pp.getAttribute('data-vid');
      var ctaPrice = pp.querySelector('[data-cta-price]');
      var mBase = pp.querySelector('[data-modal-base]');
      var mPrice = pp.querySelector('[data-modal-price]');
      var mCtaPrice = pp.querySelector('[data-modal-cta-price]');
      var opts = pp.querySelectorAll('[data-opt]');

      function selectOpt(opt) {
        vid = opt.getAttribute('data-vid');
        var price = opt.getAttribute('data-vprice') || '';
        var name = opt.getAttribute('data-vname') || '';
        opts.forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('on', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (ctaPrice) { ctaPrice.textContent = price; }
        if (mPrice) { mPrice.textContent = price; }
        if (mCtaPrice) { mCtaPrice.textContent = price; }
        if (mBase) { mBase.textContent = name; }
      }
      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { if (!opt.disabled) { selectOpt(opt); } });
      });

      /* modal */
      var modal = pp.querySelector('[data-modal]');
      var openBtn = pp.querySelector('[data-open]');
      var lastFocus = null;
      function open() {
        if (!modal) { return; }
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var f = modal.querySelector('.pp-file');
        if (f) { f.focus(); }
      }
      function close() {
        if (!modal) { return; }
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
      }
      if (openBtn) { openBtn.addEventListener('click', open); }
      if (modal) {
        modal.querySelectorAll('[data-close]').forEach(function (c) { c.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) { close(); }
        });
      }

      /* photo input */
      var photoInput = pp.querySelector('[data-photo]');
      var photoWrap = photoInput ? photoInput.closest('.pp-file') : null;
      var photoLabel = photoWrap ? photoWrap.querySelector('[data-plabel]') : null;
      if (photoInput) {
        photoInput.addEventListener('change', function () {
          if (photoInput.files && photoInput.files[0]) {
            if (photoLabel) { photoLabel.textContent = '✓ ' + photoInput.files[0].name; }
            if (photoWrap) { photoWrap.classList.add('is-on'); }
          }
        });
      }
      function getPhoto() { return (photoInput && photoInput.files && photoInput.files[0]) ? photoInput.files[0] : null; }

      /* submit -> cart -> checkout */
      var submit = pp.querySelector('[data-submit]');
      var err = pp.querySelector('[data-error]');
      var photoKey = pp.getAttribute('data-k-photo') || 'Photo';
      var baseKey = pp.getAttribute('data-k-base') || '';
      var photoRequired = pp.getAttribute('data-require-photo') === '1';

      function showErr(msg) {
        if (!err) { return; }
        err.textContent = msg;
        err.hidden = false;
      }

      if (submit) {
        submit.addEventListener('click', function () {
          if (err) { err.hidden = true; }
          var photo = getPhoto();
          if (photoRequired && !photo) {
            showErr('Please add a photo — it is what gets printed on the plaque.');
            return;
          }
          var props = {};
          if (modal) {
            modal.querySelectorAll('[data-pk]').forEach(function (el) {
              var v = (el.value || '').trim();
              if (v) { props[el.getAttribute('data-pk')] = v; }
            });
          }
          var sel = pp.querySelector('[data-opt].on');
          if (sel && baseKey) { props[baseKey] = sel.getAttribute('data-vname') || ''; }

          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', '1');
          Object.keys(props).forEach(function (k) { if (props[k]) { fd.append('properties[' + k + ']', props[k]); } });
          if (photo) { fd.append('properties[' + photoKey + ']', photo, photo.name || 'photo'); }

          var orig = submit.innerHTML;
          submit.disabled = true;
          submit.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
            if (!r.ok) { throw new Error('add'); }
            return r.json();
          }).then(function () {
            window.location.href = '/checkout';
          }).catch(function () {
            submit.disabled = false;
            submit.innerHTML = orig;
            showErr('Something went wrong adding to cart. Please try again.');
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-sample-songs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.ss[data-section-id]').forEach(function (sec) {
      var cards = [].slice.call(sec.querySelectorAll('.ss-card'));
      var grid = sec.querySelector('.ss-grid');
      var empty = sec.querySelector('.ss-empty');

      // Build filter chips from the cards' categories
      var bar = sec.querySelector('.ss-filters');
      if (bar) {
        var cats = [];
        cards.forEach(function (c) {
          var v = (c.getAttribute('data-cat') || '').trim();
          if (v && cats.indexOf(v) === -1) cats.push(v);
        });
        if (cats.length > 1) {
          bar.hidden = false;
          ['All'].concat(cats).forEach(function (cat, i) {
            var b = document.createElement('button');
            b.className = 'ss-chip';
            b.type = 'button';
            b.textContent = cat;
            b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
            b.addEventListener('click', function () {
              [].forEach.call(bar.children, function (x) { x.setAttribute('aria-pressed', 'false'); });
              b.setAttribute('aria-pressed', 'true');
              var shown = 0;
              cards.forEach(function (c) {
                var hit = cat === 'All' || c.getAttribute('data-cat') === cat;
                c.classList.toggle('is-hidden', !hit);
                if (hit) shown++;
              });
              if (empty) empty.hidden = shown > 0;
            });
            bar.appendChild(b);
          });
        }
      }

      // Players self-wire via snippets/song-player.liquid (play/pause/seek/progress,
      // and pausing other players when one starts — across all .sb-player on the page).
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pride-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.prd').forEach(function (root) {
      if (root.__prdWired) return;
      root.__prdWired = true;
      var cards = [].slice.call(root.querySelectorAll('.prd-card'));
      cards.forEach(function (card) {
        var a = card.querySelector('[data-prd-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-prd-play]');
        var prog = card.querySelector('.prd-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["song-library"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.sgl').forEach(function (root) {
      if (root.__sglWired) return;
      root.__sglWired = true;
      var grid = root.querySelector('[data-sgl-grid]');
      var pills = root.querySelector('[data-sgl-pills]');
      var activePill = root.querySelector('[data-sgl-active-pill]');
      var browseBtn = root.querySelector('[data-sgl-browse]');
      var sheet = root.querySelector('[data-sgl-sheet]');
      var scrim = root.querySelector('[data-sgl-scrim]');
      var search = root.querySelector('[data-sgl-search]');
      var empty = root.querySelector('.sgl-empty');
      var xlink = root.querySelector('[data-sgl-xlink]');
      var cards = [].slice.call(root.querySelectorAll('.sgl-card'));
      var tiles = [].slice.call(root.querySelectorAll('[data-sgl-tile]'));
      var state = { occ: '', q: '' };
      var PRIMARY = {}, LABELS = {};
      [].forEach.call(pills ? pills.querySelectorAll('.sgl-pill') : [], function (b) {
        if (b === activePill) return;
        var k = b.getAttribute('data-occ');
        if (k) PRIMARY[k] = true;
      });
      tiles.forEach(function (t) {
        var nm = t.querySelector('.sgl-tile-name');
        LABELS[t.getAttribute('data-occ')] = nm ? nm.textContent : t.getAttribute('data-occ');
      });

      cards.forEach(function (card) {
        var a = card.querySelector('[data-sgl-audio]');
        if (!a) return;
        var btn = card.querySelector('[data-sgl-play]');
        var prog = card.querySelector('.sgl-prog i');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (a.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== a) o.pause(); }); a.play().catch(function () {}); }
          else a.pause();
        });
        a.addEventListener('play', function () { card.classList.add('is-playing'); });
        a.addEventListener('pause', function () { card.classList.remove('is-playing'); });
        a.addEventListener('ended', function () { card.classList.remove('is-playing'); if (prog) prog.style.width = '0'; });
        a.addEventListener('timeupdate', function () { if (prog) prog.style.width = (a.currentTime / (a.duration || 1) * 100) + '%'; });
      });

      function apply() {
        var shown = 0;
        cards.forEach(function (card) {
          var okc = state.occ === '' || card.getAttribute('data-occ') === state.occ;
          var qc = state.q === '' || card.getAttribute('data-title').indexOf(state.q) !== -1;
          var ok = okc && qc;
          card.classList.toggle('is-hidden', !ok);
          if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      }
      function syncURL() {
        var params = new URLSearchParams();
        if (state.occ) params.set('occasion', state.occ);
        if (state.q) params.set('q', state.q);
        var qs = params.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
      }
      function openSheet() {
        if (!sheet) return;
        if (scrim) scrim.hidden = false;
        sheet.hidden = false;
        requestAnimationFrame(function () { sheet.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); });
        if (browseBtn) browseBtn.setAttribute('aria-expanded', 'true');
        if (window.matchMedia('(max-width:699px)').matches) document.body.style.overflow = 'hidden';
      }
      function closeSheet() {
        if (!sheet) return;
        sheet.classList.remove('is-open');
        if (scrim) scrim.classList.remove('is-open');
        if (browseBtn) browseBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () { sheet.hidden = true; if (scrim) scrim.hidden = true; }, 260);
      }
      function setOcc(occ) {
        state.occ = occ;
        if (pills) [].forEach.call(pills.querySelectorAll('.sgl-pill'), function (b) {
          if (b === activePill) return;
          b.setAttribute('aria-pressed', b.getAttribute('data-occ') === occ ? 'true' : 'false');
        });
        var isPrimary = occ === '' || PRIMARY[occ];
        if (activePill) {
          if (isPrimary) {
            activePill.hidden = true;
          } else {
            activePill.hidden = false;
            activePill.setAttribute('data-occ', occ);
            activePill.setAttribute('aria-pressed', 'true');
            activePill.innerHTML = (LABELS[occ] || occ) + ' <span class="sgl-pill-x" aria-hidden="true">×</span>';
          }
        }
        if (browseBtn) browseBtn.classList.toggle('is-active', !isPrimary);
        tiles.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-occ') === occ ? 'true' : 'false'); });
        if (xlink) xlink.hidden = occ !== 'pride';
        apply(); syncURL();
      }
      if (pills) pills.addEventListener('click', function (e) {
        var b = e.target.closest('.sgl-pill');
        if (!b) return;
        if (b === activePill) { setOcc(''); return; }
        setOcc(b.getAttribute('data-occ') || '');
      });
      tiles.forEach(function (t) {
        t.addEventListener('click', function () { setOcc(t.getAttribute('data-occ') || ''); closeSheet(); });
      });
      if (browseBtn) browseBtn.addEventListener('click', openSheet);
      if (scrim) scrim.addEventListener('click', closeSheet);
      var sheetX = root.querySelector('[data-sgl-sheet-x]');
      if (sheetX) sheetX.addEventListener('click', closeSheet);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });
      if (search) search.addEventListener('input', function () { state.q = search.value.trim().toLowerCase(); apply(); syncURL(); });

      var p = new URLSearchParams(location.search);
      var o = (p.get('occasion') || '').toLowerCase();
      var q = p.get('q') || '';
      if (q) { state.q = q.toLowerCase(); if (search) search.value = q; }
      if (o && (PRIMARY[o] || LABELS[o])) setOcc(o);
      else apply();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["song-page"]) return;
  try {
    
(function () {
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); var m = Math.floor(s / 60), x = s % 60; return m + ':' + (x < 10 ? '0' : '') + x; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function init() {
    document.querySelectorAll('.sgp').forEach(function (root) {
      if (root.__sgpWired) return;
      root.__sgpWired = true;
      var audio = root.querySelector('[data-sgp-audio]');
      var np = root.querySelector('.sgp-np');
      var mini = root.querySelector('[data-sgp-mini]');
      var bar = root.querySelector('[data-sgp-bar]');
      var scrub = root.querySelector('[data-sgp-scrub]');
      var curEl = root.querySelector('[data-sgp-cur]');
      var durEl = root.querySelector('[data-sgp-dur]');
      if (!audio) return;
      function paint(p) { p = clamp(p, 0, 1); if (scrub) { scrub.style.setProperty('--p', (p * 100).toFixed(2) + '%'); scrub.setAttribute('aria-valuenow', String(Math.round(p * 100))); } }
      function toggle() { if (audio.paused) { document.querySelectorAll('audio').forEach(function (o) { if (o !== audio) o.pause(); }); audio.play().catch(function () {}); } else { audio.pause(); } }
      root.querySelectorAll('[data-sgp-play]').forEach(function (b) { b.addEventListener('click', toggle); });
      var restart = root.querySelector('[data-sgp-restart]');
      if (restart) restart.addEventListener('click', function () { audio.currentTime = 0; audio.play().catch(function () {}); });
      var repeat = root.querySelector('[data-sgp-repeat]');
      if (repeat) repeat.addEventListener('click', function () { audio.loop = !audio.loop; repeat.setAttribute('aria-pressed', audio.loop ? 'true' : 'false'); });
      audio.addEventListener('play', function () { root.classList.add('sgp-playing'); });
      audio.addEventListener('pause', function () { root.classList.remove('sgp-playing'); });
      audio.addEventListener('ended', function () { paint(0); if (curEl) curEl.textContent = '0:00'; });
      audio.addEventListener('loadedmetadata', function () { if (durEl && isFinite(audio.duration)) durEl.textContent = fmt(audio.duration); });
      audio.addEventListener('timeupdate', function () { var d = audio.duration || 0; paint(d ? audio.currentTime / d : 0); if (curEl) curEl.textContent = fmt(audio.currentTime); });
      if (scrub) {
        var seek = function (x) { var r = scrub.getBoundingClientRect(); var f = clamp((x - r.left) / r.width, 0, 1); if (isFinite(audio.duration) && audio.duration) { audio.currentTime = f * audio.duration; paint(f); if (curEl) curEl.textContent = fmt(audio.currentTime); } };
        var drag = false;
        scrub.addEventListener('pointerdown', function (e) { drag = true; try { scrub.setPointerCapture(e.pointerId); } catch (err) {} seek(e.clientX); });
        scrub.addEventListener('pointermove', function (e) { if (drag) seek(e.clientX); });
        scrub.addEventListener('pointerup', function () { drag = false; });
        scrub.addEventListener('pointercancel', function () { drag = false; });
        scrub.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration); }
          else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
        });
      }
      paint(0);
      if (np && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (bar) bar.classList.toggle('sgp-solid', !en.isIntersecting);
            if (mini) mini.classList.toggle('sgp-show', !en.isIntersecting);
          });
        }, { rootMargin: '-70px 0px 0px 0px', threshold: 0 }).observe(np);
      }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();
})();
